import * as ActionTypes from "../ActionTypes.js";

export const addMessage = (dispatch, payload) => {
  dispatch({ type: ActionTypes.ADD_MESSAGE, payload: payload });
};

export const deleteMessage = (dispatch) => {
  dispatch({ type: ActionTypes.DELETE_MESSAGE });
};

export const toggleLost = (dispatch) => {
  dispatch({ type: ActionTypes.TOGGLE_LOST_MODAL });
};

export const toggleFound = (dispatch) => {
  dispatch({ type: ActionTypes.TOGGLE_FOUND_MODAL });
};
